import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/merch-support")({
  component: MerchSupportRedirect,
});

function MerchSupportRedirect() {
  return <Navigate to="/support" replace />;
}
